/* unplugin-vue-components disabled */import { render } from "./notesComponent.vue?vue&type=template&id=9da281b8&scoped=true"
import script from "./notesComponent.vue?vue&type=script&lang=js"
export * from "./notesComponent.vue?vue&type=script&lang=js"

import "./notesComponent.vue?vue&type=style&index=0&id=9da281b8&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9da281b8"]])

export default __exports__